import React from "react";
import { useSelector } from 'react-redux';

const GalleryView = () => {
  const eventData = useSelector((state) => state.event.eventData || {});
  const gallery = eventData.gallery || [];

  const backgroundImage = gallery.length > 0 ? gallery[0].imageKey : "";
  const subevent = eventData.events?.awards || [];

  return (
    <div className="overflow-hidden space-bottom">
      <section
        className="tour-area position-relative bg-top-center overflow-hidden space"
        id="service-sec"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="title-area text-center">
                <span className="sub-title">Make Your Tour More Pleasure</span>
                <h2 className="sec-title">Recent Gallery</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
       
        <div className="row  gy-24 gx-24 justify-content-center">
          {gallery.map((block, idx) => (
            <div key={idx} className={block.col || "col-lg-3"}>
              <GalleryImage src={block.imageKey} />
              {block.nested?.map((item, i) =>
                item.wrap ? (
                  <div key={i} className="gallery-box-wrapp">
                    {item.images?.map((img, j) => (
                      <GalleryImage key={j} src={img.src} />
                    ))}
                  </div>
                ) : (
                  <GalleryImage key={i} src={item.src} />
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

function GalleryImage({ src }) {
  return (
    <div className="gallery-box mt-12 style2">
      <br/>
      <div className="gallery-img global-img " >
        <a href={src} className="popup-image">
          <div className="icon-btn">
            <i className="fal fa-magnifying-glass-plus"></i>
          </div>
          <img src={src} alt="gallery" />
        </a>
      </div>
    </div>
  );
}

export default GalleryView;
